import { useCanDesignateLeaders, useFeatureAccessSettings } from '../featureAccessSettings';

type UseCanUserAccessLeadershipCornerWithoutLeaders = () => boolean;
export const useCanUserAccessLeadershipCornerWithoutLeaders: UseCanUserAccessLeadershipCornerWithoutLeaders = () => {
  const featureAccessSettings = useFeatureAccessSettings();
  const canDesignateLeaders = useCanDesignateLeaders();

  return !!featureAccessSettings?.viewerCanAccessLeadershipCorner && canDesignateLeaders;
};
